import { reactive } from 'vue'

import { useConfigStore } from '@/store/config'
import { useTillStore } from '@/store/till'
import type { EventName } from '@/types/events'

import PrinterQueue from './printerQueue'
import type { Printer } from './types'

export let queues: Record<string, PrinterQueue> = reactive({})

function loadPrinters(printers: Printer[]) {
  // We group IP printers to share the same queue
  const ipQueues = printers.reduce(
    (res, printer) => {
      try {
        if (!printer.ip) return res
        res[printer.ip] = new PrinterQueue(printer)
      } catch {
        // Unsupported printer
      }
      return res
    },
    {} as Record<string, PrinterQueue>
  )

  queues = reactive(
    printers.reduce(
      (res, printer) => {
        try {
          if (printer.ip) res[printer.id] = ipQueues[printer.ip]
          else res[printer.id] = new PrinterQueue(printer)
        } catch {
          // Unsupported printer
        }
        return res
      },
      {} as Record<string, PrinterQueue>
    )
  )

  const { currentAdyenDataphone } = useConfigStore()
  if (currentAdyenDataphone) {
    queues['self'] = new PrinterQueue({
      id: 'self',
      name: 'Adyen Dataphone',
      type: 'AdyenPrinter',
      metadata: {
        poiid: currentAdyenDataphone.poiid
      },
      // Not needed
      ip: 'none',
      ticketWidth: 0,
      ticketHeight: 0,
      ticketPaddingLeft: 0,
      splitProducts: false,
      tillEnabled: false,
      tillId: ''
    })
  }
}

function printImage(
  printerId: string,
  imageData: HTMLCanvasElement,
  copies: number = 1,
  printedEvent?: {
    name: EventName
    data: any
  }
) {
  for (let i = 0; i < copies; ++i) {
    const queue = queues[printerId]
    if (queue) {
      queue.addJob({
        type: 'printImage',
        image: imageData,
        printedEvent,
        time: new Date()
      })
    }
  }
}

function openCashDrawer() {
  const till = useTillStore()
  const config = useConfigStore()
  const printerId =
    (till.selectedCashTill && till.selectedCashTill.printerId) || config.config.defaultBillPrinter
  if (!printerId) return
  const queue = queues[printerId]
  if (queue) {
    queue.addJob({
      type: 'openCashDrawer'
    })
  }
}

export default { printImage, openCashDrawer, loadPrinters }
